import React from "react";
import { Modal, ModalManager, ModalContent } from "src/components/Modal";
import { Text } from "src/components/Text";
import { Box } from "src/components/Box";
import Loader from "@asphalt-react/loader";
import { useTranslation } from "src/hooks/useTranslation";
import styled from "styled-components";

type Props = {
  show: boolean;
  text?: string;
};

const ModalManagerEl = styled(ModalManager)`
  justify-content: center;
  align-items: center;
`;

export const LoadingOverlay = ({ show, text }: Props) => {
  const translate = useTranslation();

  return (
    <ModalManagerEl showModal={show} onClose={() => {}} modalSize="s">
      <Modal>
        <ModalContent>
          <Box flex alignItemsCenter flexDirectionColumn>
            <Loader />
            <Text marginTopXl fontWeight="demi">
              {text || translate("generic.loading.text")}
            </Text>
          </Box>
        </ModalContent>
      </Modal>
    </ModalManagerEl>
  );
};
